var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPressure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9992,
    cy: 36,
    r: 4.8,
    fill: "#9BCAEB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9992,
    cy: 36,
    r: 4.8,
    fill: "#9BCAEB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.9992,
    cy: 36,
    r: 4.8,
    fill: "#9BCAEB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9996,
    cy: 21.6,
    r: 2.4,
    fill: "#9BCAEB"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9996,
    cy: 21.6,
    r: 2.4,
    fill: "#9BCAEB"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.9996,
    cy: 21.6,
    r: 2.4,
    fill: "#9BCAEB"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 11.9996,
    cy: 9.60001,
    r: 2.4,
    fill: "#9BCAEB"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 23.9996,
    cy: 9.60001,
    r: 2.4,
    fill: "#9BCAEB"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 35.9996,
    cy: 9.60001,
    r: 2.4,
    fill: "#9BCAEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressure);
export default __webpack_public_path__ + "static/media/pressure.83525cff8bdff1446bbfdbcca68532ff.svg";
export { ForwardRef as ReactComponent };